import { configureStore } from "@reduxjs/toolkit";
import auth from "./slices/authSlice";
import interfaceApp from "./slices/interfaceSlice";
import clubs from "./slices/clubsSlice";

export const store = configureStore({
  reducer: {
    auth,
    interfaceApp,
    clubs,
  },
});
